"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAGINATION_SIZE = exports.FIRST_PAGE = exports.PRE_PAGE = exports.LAST_PAGE = exports.NEXT_PAGE = exports.PAGE_START_INDEX = exports.SIZE_PER_PAGE_LIST = exports.PAGE_SKIP = exports.DEFAULT_PRE_PAGE = exports.DEFAULT_NEXT_PAGE = exports.SIZE_PER_PAGE = void 0;
var SIZE_PER_PAGE = 10;
exports.SIZE_PER_PAGE = SIZE_PER_PAGE;
var DEFAULT_NEXT_PAGE = '>';
exports.DEFAULT_NEXT_PAGE = DEFAULT_NEXT_PAGE;
var DEFAULT_PRE_PAGE = '<';
exports.DEFAULT_PRE_PAGE = DEFAULT_PRE_PAGE;
var PAGE_SKIP = '...';
exports.PAGE_SKIP = PAGE_SKIP;
var SIZE_PER_PAGE_LIST = [10, 20, 50, 100];
exports.SIZE_PER_PAGE_LIST = SIZE_PER_PAGE_LIST;
var PAGE_START_INDEX = 1;
exports.PAGE_START_INDEX = PAGE_START_INDEX;
var NEXT_PAGE = '>';
exports.NEXT_PAGE = NEXT_PAGE;
var LAST_PAGE = '>>';
exports.LAST_PAGE = LAST_PAGE;
var PRE_PAGE = '<';
exports.PRE_PAGE = PRE_PAGE;
var FIRST_PAGE = '1';
exports.FIRST_PAGE = FIRST_PAGE;
var PAGINATION_SIZE = 11;
exports.PAGINATION_SIZE = PAGINATION_SIZE;